var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"al"},[_c('filterCommon4',{on:{"select":_vm.select}}),_c('actItem',{attrs:{"topic":_vm.topic,"nameEn":_vm.nameEn,"typeId":_vm.typeId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }